import Vue from "vue";
import { BVToastPlugin, BVModalPlugin } from "bootstrap-vue";
import { NOTIFICATION_TOAST_VARIANTS_MAP } from "@/constants";
import { getAxiosErrorMessage, isNetworkError } from "./network-utils";

function setupApp() {
  if (process.env.VUE_APP_COMPAT) {
    /**
     * Creating a new application instance triggers a multi-instance warning for BootstrapVue.
     * This is due to the fact that the toast and modal window is created only for the first instance,
     * and will not work for the rest (it is useless to use BVModalPlugin and BVToastPlugin in several places).
     * Therefore, it is necessary to assign $bvModal = modal in when creating the main instance
     */
    const app = Vue.createApp();
    app.use(BVToastPlugin);
    app.use(BVModalPlugin);
    return app.mount("#toast");
  } else {
    Vue.use(BVToastPlugin);
    Vue.use(BVModalPlugin);
    // Toasts do not support calling them without class instance
    // https://github.com/bootstrap-vue/bootstrap-vue/issues/3262
    // It is also necessary to prevent the notification from disappearing immediately.
    return new Vue();
  }
}

const mountedApp = setupApp();
const toast = mountedApp.$bvToast;
export const modal = mountedApp.$bvModal;

export const notify = (title, type) => {
  const variant = NOTIFICATION_TOAST_VARIANTS_MAP[type];
  toast.toast(title, {
    variant,
    autoHideDelay: 3000,
  });
};

export const notifySuccess = (title) => notify(title, "success");
export const notifyError = (title) => notify(title, "error");
export const notifyWarning = (title) => notify(title, "warning");

export const notifyAxiosError = (error) => {
  notifyError(getAxiosErrorMessage(error));
};

export const processAxiosNetworkError = (error, returnValue) => {
  if (isNetworkError(error)) {
    notifyAxiosError(error);
    return returnValue;
  }
  throw error;
};

export const showMsgBoxConfirm = (text) => modal.msgBoxConfirm(text);
